import { logInfo } from "./logger";

const getLocalStorageItem = <T>(key: string, defaultValue: T) => {
  try {
    return JSON.parse(
      localStorage.getItem(key) ?? JSON.stringify(defaultValue),
    );
  } catch (error) {
    logInfo(error);
  }
  return defaultValue;
};

export { getLocalStorageItem };
